export default "__VITE_ASSET__bsWRtVMM__"